export default __webpack_public_path__ + "b769a694a10d3ec1890d9d9a762b7521.png";